

export default class LocalisationManager {
    constructor (){
        LocalisationManager.Instance = this;

        this.language = 'en';
        this.localisationData = {};

    }

    SetLocalisationData(language, localisationData){
        this.language = language;
        this.localisationData = localisationData;
    }
    
    GetString(key) {
        //return "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        if (!this.localisationData) {
            //console.log("LocalisationUtility : No JSON data found");
            return key;
        }
    
        var data = this.localisationData[key];
        if (!data) {
            //console.log("LocalisationUtility : No entry found for key " + key)
            return key;
        }
    
        var locText = data[this.language];
        if (!locText) {
            //console.log("LocalisationUtility : No " + this.language + " language entry found for key " + key)
            return data["en"];
        }
    
        return locText;
    };
    
} 